'use strict';

var _extend2 = _interopRequireDefault(require("lodash/extend"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _partial2 = _interopRequireDefault(require("lodash/partial"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _keys2 = _interopRequireDefault(require("lodash/keys"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var formatio = require('formatio');

module.exports =
/*#__PURE__*/
function () {
  function Deferred(darc, value) {
    _classCallCheck(this, Deferred);

    this.darc = darc;
    this.isPending = true;
    this.isFulfilled = false;
    this.isRejected = false;
    this.value = null;
    this.reason = null;
    this.listeners = [];

    if (arguments.length > 1) {
      if (value && value.then) {
        this.once(value);
      } else {
        this.fulfil(value);
      }
    }
  }

  _createClass(Deferred, [{
    key: "once",
    value: function once(handler) {
      var _this = this;

      if (handler.then) {
        handler.then(this.fulfil.bind(this)).catch(this.reject.bind(this));
      } else {
        try {
          handler(function (result) {
            _this.fulfil(result);
          }, function (reason) {
            _this.reject(reason);
          });
        } catch (e) {
          this.reject(e);
        }
      }

      return this;
    }
  }, {
    key: "child",
    value: function child(evaluate, isCatch) {
      var child = new Deferred(this.darc);
      child.callback = evaluate;
      child.isCatch = isCatch;
      return child;
    }
  }, {
    key: "propagate",
    value: function propagate(child) {
      var value = this.value,
          reason = this.reason;
      var isImmediatelyCaught = !this.isRejected;

      try {
        if (child.isCatch) {
          if (this.isRejected) {
            value = child.callback(reason);
            isImmediatelyCaught = this.isCaught = true;
          }
        } else if (!this.isRejected) {
          value = child.callback(value);
        }
      } catch (e) {
        child.reject(e);

        if (child.isCaught) {
          this.isCaught = true;
        }

        return;
      }

      if (value && value.then) {
        child.once(value);
      } else if (this.isRejected && !isImmediatelyCaught) {
        child.reject(reason);

        if (child.isCaught) {
          this.isCaught = true;
        }
      } else if (this.isFulfilled || isImmediatelyCaught) {
        child.fulfil(value);
      }
    }
  }, {
    key: "race",
    value: function race(array) {
      var _this2 = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var object = _step.value;

          if (object && object.then) {
            object.then(function (result) {
              if (_this2.isPending) {
                _this2.fulfil(result);
              }
            }).catch(function (reason) {
              if (_this2.isPending) {
                _this2.reject(reason);
              }
            });
          } else {
            this.fulfil(object);
          }

          if (!this.isPending) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this;
    }
  }, {
    key: "all",
    value: function all(objectOrArray) {
      var _this3 = this;

      var keyCount = (0, _keys2.default)(objectOrArray).length;
      var output;

      if ((0, _isArray2.default)(objectOrArray)) {
        output = [];
      } else {
        output = {};
      }

      if (!keyCount) {
        this.fulfil(output);
        return this;
      }

      var set = function set(key, result) {
        output[key] = result;

        if (! --keyCount) {
          _this3.fulfil(output);
        }
      };

      for (var key in objectOrArray) {
        var element = objectOrArray[key];

        if (element && element.then) {
          element.then((0, _partial2.default)(set, key)).catch(this.reject.bind(this));
        } else {
          set(key, element);
        }
      }

      return this;
    }
  }, {
    key: "fulfil",
    value: function fulfil(result) {
      if (this.isPending) {
        this.isPending = false;
        this.isFulfilled = true;
        this.value = result;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.listeners[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var listener = _step2.value;
            this.propagate(listener);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else {
        this.darc.log('Deferred fulfilled twice');
      }

      return this;
    }
  }, {
    key: "reject",
    value: function reject(reason) {
      var _this4 = this;

      if (this.isPending) {
        this.isPending = false;
        this.isRejected = true;
        this.reason = reason;
        var rejectionStack = new Error().stack;
        setTimeout(function () {
          if (!_this4.isCaught) {
            var error = new Error((0, _get2.default)(reason, 'message', reason || 'No message'));
            error.stack = rejectionStack;
            error.tags = (0, _extend2.default)({
              isDeferred: true
            }, (0, _get2.default)(reason, 'tags', {}));

            _this4.darc.console.warn(error);
          }
        }, 1000);
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this.listeners[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var listener = _step3.value;
            this.propagate(listener);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } else {
        this.darc.log('Deferred rejected after completed');
      }

      return this;
    }
  }, {
    key: "then",
    value: function then(callback, rejectCallback) {
      if (typeof callback !== 'function') {
        this.darc.console.warn('Undefined callback for deferred then');
        return this;
      }

      if (rejectCallback) {
        this.catch(rejectCallback);
      }

      if (this.isFulfilled) {
        try {
          var output = callback(this.value);

          if (output && output.then) {
            return output;
          } else {
            return new Deferred(this.darc, output);
          }
        } catch (e) {
          return new Deferred(this.darc).reject(e);
        }
      } else if (this.isPending) {
        var child = this.child(callback);
        this.listeners.push(child);
        return child;
      } // Error state


      return this;
    }
  }, {
    key: "catch",
    value: function _catch(callback) {
      if (typeof callback !== 'function') {
        this.darc.console.warn('Undefined callback for deferred catch');
        return this;
      }

      if (this.isRejected) {
        this.isCaught = true;

        try {
          var output = callback(this.reason);

          if (output && output.then) {
            return output;
          } else {
            return new Deferred(this, output);
          }
        } catch (e) {
          return new Deferred(this).reject(e);
        }
      } else if (this.isPending) {
        var child = this.child(callback, true);
        this.listeners.push(child);
        return child;
      } // Error state


      return this;
    }
  }, {
    key: "maybe",
    value: function maybe(callback) {
      return this.darc.maybe(this, callback);
    }
  }, {
    key: "finally",
    value: function _finally(callback) {
      this.then(callback);
      this.catch(callback);
    }
  }]);

  return Deferred;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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